// @flow

import React from "react";
import { Icon, Grid, Card, Table, Form, Button, Page } from "tabler-react";
import { Link } from "react-router-dom";
import SiteWrapperSuperAdmin from "../../SiteWrapper.superadmin.react";
import SiteWrapperHospitalSuperAdmin from "../SiteWrapper.hospital.superadmin.react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import authActions from "../../../redux/auth/action";
import {
  getAppointmentModes,
  deleteAppointmentMode,
} from "../../../services/hospital";
import { changeLanguage } from "../../../language/index";

import socketIOClient from "socket.io-client";
var { jwtToken } = localStorage;
// var ENDPOINT = "https://waagentportal.rpsapi.in";
var ENDPOINT = process.env.REACT_APP_baseUrl;
var socket = socketIOClient(ENDPOINT, { query: `authorization=${jwtToken}` });
// import Loader from '../../common/Loader/loader'

const paginationLimit = 10;

class AppointModeList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: this.props.match.params.page,
      appointmentModeArr: [],
      totalRecords: 0,
      nextPage: false,
      prevoiusPage: false,
      search: "",
      isLoading: true,
      // openDownloadPopup: false,
    };
    this.search = this.search.bind(this);
  }

  componentDidMount() {
    if (!this.props.isLoggedIn) {
      this.props.history.push("/login");
    }
    document.title = "Voiceoc | Appointment Mode List";
    this.callService(this.state.currentPage);
  }

  //handle change
  handleChange = (e, field) => {
    this.setState({ search: e.target.value });
  };

  setLoadingToggle(value) {
    this.setState({ isLoading: value });
  }

  removeAppointmentMode = (event, id) => {
    if (window.confirm("Are you sure to delete this Appointment  Mode?")) {
      event.preventDefault();
      const { currentPage } = this.state;
      const { search } = this.state;

      this.setLoadingToggle(true);

      deleteAppointmentMode(id)
        .then((response) => {
          toast.success("Appointment Mode Deleted Successfully.");
          this.callService(currentPage, search);
        })
        .catch((error) => {
          if (error.response && error.response.data.message)
            toast.error(error.response.data.message);
          else if (error.message) toast.error(error.message);
          else toast.error(error);
          this.setLoadingToggle(false);
        });
    }
  };

  callService(page, search = false) {
    getAppointmentModes(page, search).then((res) => {
      console.info(res);
      this.setState(() => ({
        appointmentModeArr: res.data.result,
        nextPage: res.data.next,
        totalRecords: res.data.total,
        prevoiusPage: this.state.currentPage > 1 ? true : false,
      }));
    });
  }

  pagination(e, page) {
    this.callService(page);
    this.props.history.push("/admin/hospitaltabs/appointmentmode/" + page);
  }

  search(clear = false) {
    if (clear) {
      this.setState({
        search: "",
      });
    }
    setTimeout(() => {
      this.callService(1, this.state.search);
    }, 100);
  }

  handleViewClient(path, client) {
    this.props.adminLoginAsClient(client);
  }

  getPagination() {
    let startRecord =
      this.props.match.params.page == 1
        ? this.props.match.params.page
        : paginationLimit * (this.props.match.params.page - 1) + 1;
    let endRecord =
      parseInt(startRecord) +
      parseInt(this.state.appointmentModeArr.length) -
      1;
    return startRecord + "-" + endRecord + " of " + this.state.totalRecords;
  }

  render() {
    const pageNumber = this.props.match.params.page;
    const finalNumeber = (pageNumber - 1) * paginationLimit;
    // return(<h1>WAIT</h1>)
    return (
      <SiteWrapperHospitalSuperAdmin>
        <Page.Content>
          <Grid.Row>
            <Grid.Col lg={12}>
              <Card>
                <Card.Header>
                  <Card.Title>
                    {" "}
                    {changeLanguage(
                      this.props.siteLanguage,
                      "appointment_modes",
                    )}
                  </Card.Title>
                  <Form.Group label="" className="ml-auto">
                    <Form.InputGroup className="ml-auto1">
                      <Form.Input
                        placeholder="Search..."
                        className="ml-auto1 "
                        name="search"
                        value={this.state.search}
                        onChange={(e) => this.handleChange(e, "search")}
                      />
                      <Form.InputGroupAppend>
                        <Button
                          color="primary"
                          className="ml-auto1 btn1a"
                          onClick={(e) => this.search()}
                        >
                          {changeLanguage(this.props.siteLanguage, "go")}
                        </Button>
                        <Button
                          color="primary"
                          className="ml-auto1 ml-auto10 btn1a"
                          onClick={(e) => this.search(true)}
                        >
                          {changeLanguage(this.props.siteLanguage, "clear")}
                        </Button>
                      </Form.InputGroupAppend>
                    </Form.InputGroup>
                  </Form.Group>
                </Card.Header>
                <Table
                  cards={true}
                  striped={true}
                  responsive={true}
                  className="table-vcenter table-hover"
                >
                  <Table.Header>
                    <Table.Row>
                      <Table.ColHeader>
                        {" "}
                        {changeLanguage(this.props.siteLanguage, "sl_no")}
                      </Table.ColHeader>
                      <Table.ColHeader>
                        {changeLanguage(this.props.siteLanguage, "name_en")}
                      </Table.ColHeader>
                      <Table.ColHeader>
                        {changeLanguage(this.props.siteLanguage, "name_id")}
                      </Table.ColHeader>
                      <Table.ColHeader>
                        {changeLanguage(
                          this.props.siteLanguage,
                          "appointment_mode_id",
                        )}
                      </Table.ColHeader>
                      <Table.ColHeader>
                        {changeLanguage(this.props.siteLanguage, "hospital_id")}
                      </Table.ColHeader>
                      <Table.ColHeader className="center">
                        {changeLanguage(this.props.siteLanguage, "action")}
                      </Table.ColHeader>
                    </Table.Row>
                  </Table.Header>
                  <Table.Body>
                    {this.state.appointmentModeArr &&
                    this.state.appointmentModeArr.length ? (
                      this.state.appointmentModeArr.map(
                        (appointmentMode, index) => (
                          <Table.Row key={index}>
                            <Table.Col>{index + 1 + finalNumeber}</Table.Col>
                            <Table.Col>{appointmentMode.name_en}</Table.Col>
                            <Table.Col>{appointmentMode.name_id}</Table.Col>
                            <Table.Col>{appointmentMode.id}</Table.Col>
                            <Table.Col>{appointmentMode.hospital_id}</Table.Col>
                            <Table.Col className="text-nowrap actions chat-w1">
                              <Link
                                to={`/admin/hospitaltabs/appointmentmode/edit/${appointmentMode._id}`}
                                title={changeLanguage(
                                  this.props.siteLanguage,
                                  "click_to_edit",
                                )}
                              >
                                <Icon prefix="fa" name="edit"></Icon>
                              </Link>
                              <Link
                                to="#"
                                title={changeLanguage(
                                  this.props.siteLanguage,
                                  "click_to_delete",
                                )}
                                onClick={(e) =>
                                  this.removeAppointmentMode(
                                    e,
                                    appointmentMode._id,
                                  )
                                }
                              >
                                <Icon prefix="fa" name="trash"></Icon>
                              </Link>
                            </Table.Col>
                          </Table.Row>
                        ),
                      )
                    ) : (
                      <Table.Row>
                        <Table.Col colSpan={6}>
                          Sorry! Appointment modes not found.
                        </Table.Col>
                      </Table.Row>
                    )}
                  </Table.Body>
                </Table>
                {/* pagination */}
                <div className="form-group" style={{ float: "right" }}>
                  <label className="form-label"></label>
                  <div className="selectgroup align-to-right paginations">
                    <span>{this.getPagination()}</span>

                    <i
                      className={
                        "fe " +
                        (this.props.match.params.page <= 1
                          ? "not-active "
                          : "cursorPointer ") +
                        " fe-chevron-left"
                      }
                      onClick={(e) =>
                        this.pagination(
                          e,
                          parseInt(this.props.match.params.page) - 1,
                        )
                      }
                      disabled={this.props.match.params.page <= 1}
                    ></i>

                    <i
                      className={
                        "fe " +
                        (!this.state.nextPage
                          ? "not-active "
                          : "cursorPointer ") +
                        " fe-chevron-right"
                      }
                      onClick={(e) =>
                        this.pagination(
                          e,
                          parseInt(this.props.match.params.page) + 1,
                        )
                      }
                      disabled={!this.state.nextPage}
                    ></i>
                  </div>
                </div>
              </Card>
            </Grid.Col>
          </Grid.Row>
        </Page.Content>
        <ToastContainer autoClose={5000} position={"bottom-right"} />
      </SiteWrapperHospitalSuperAdmin>
    );
  }
}

function mapStateToProps(state) {
  return {
    isLoggedIn: state.auth.isAuthenticated,
    toast: state.auth.toast,
    siteLanguage: state.auth.siteLanguage,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    adminLoginAsClient: (payload) => {
      dispatch(authActions.adminLoginAsClient(payload));
    },
    setActiveBot: (payload) => {
      dispatch(authActions.setActiveBot(payload));
    },
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AppointModeList),
);
// export default Clients;
